// Admin-panel URL map — the admin counterpart of user-routes.js.
//
// Support's copies of merchant pages (the "Users view" and Business settings) render for the
// account in the `business_account_id` query param, so every navigation between them must
// carry the current `search` along with the path.
const AdminRoutesPaths = {
  // "Users view": the merchant's own pages, opened for `?business_account_id=`.
  users_view: {
    dashboard: "/admin/dashboard",
    dashboard_for: (businessAccountId) =>
      `/admin/dashboard?business_account_id=${businessAccountId}`,
    alerts_by_country: "/admin/dashboard/alerts_by_country",
    alerts_by_bank: "/admin/dashboard/alerts_by_bank",
    alerts: "/admin/alerts",
    alert_details: (alertId) => `/admin/alerts/details/${alertId}`,
    integrations: "/admin/integrations",
    receipts: "/admin/receipts"
  },

  disputes: "/admin/disputes",
  perks: "/admin/perks",
  payment_matching: "/admin/payment_matching",
  users_by_source: "/dashboard/users_by_source",

  users: "/users",
  user_balance: "/users/user_balance",
  admin_users: "/admin_users",
  security: "/security",
  business_accounts: "/business_accounts",

  referral: {
    root: "/referral",
    affiliate: (userId) => `/referral/affiliate/${userId}`,
    business_account: (businessAccountId) => `/referral/referral-ba/${businessAccountId}`
  },

  pricing: "/pricing",
  invoices: "/invoices",
  marketing: "/marketing",

  requests: {
    section: (hash) => `/requests/${hash}`,
    enrollments: "/requests/enrollments",
    receipts: "/requests/receipts",
    credits: "/requests/credits"
  },

  // Business settings as support opens it for a merchant. The merchant's own Business
  // settings shares the /business_settings prefix, so only support's call sites use these.
  business_settings: {
    root: "/business_settings",
    enrollment: "/business_settings/enrollment",
    auto_refund: "/business_settings/auto-refund",
    integrations: "/business_settings/integrations",
    pricing: "/business_settings/pricing",
    business: "/business_settings/business",
    users: "/business_settings/users",
    business_health_overview: "/business_settings/business_health/overview",
    chargeback_olympics: "/business_settings/business_health/overview/chargeback_olympics",
    breakdown_by_country: "/business_settings/business_health/overview/breakdown_by_country",
    breakdown_by_reason_code:
      "/business_settings/business_health/overview/breakdown_by_reason_code",
    business_health_monitoring: "/business_settings/business_health/monitoring",
    estimated_program_status:
      "/business_settings/business_health/monitoring/estimated_program_status",
    mastercard_estimated_program_status:
      "/business_settings/business_health/monitoring/mastercard_estimated_program_status"
  },

  // Business settings → Lookups → Receipt.
  receipts: {
    all: "/business_settings/lookups/receipt",
    configure_business: "/business_settings/lookups/configure",
    configure_profile: "/business_settings/lookups/configure/profile",
    configure_profile_hash: (hash) => `/business_settings/lookups/configure/profile/${hash}`
  },

  recover: {
    root: "/business_settings/recover",
    configure: "/business_settings/recover/configure",
    configure_section: (section) => `/business_settings/recover/configure/${section}`,
    preferences: "/business_settings/recover/preferences"
  }
}

// Admin addresses that moved; each is answered by a redirect — see InitComponent/legacyRoutes.jsx.
const LegacyAdminRoutesPaths = {
  // Business settings → Receipt before Lookups (CHA1-4235).
  receipts_all: "/business_settings/receipts/all",
  receipts_configure: "/business_settings/receipts/configure"
}

export { AdminRoutesPaths, LegacyAdminRoutesPaths }
